import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import user from './user/sagas';
import properties from './properties/sagas';
import property from './property/sagas';

export default function* rootSaga() {
  return yield all([auth, user, properties, property]);
}
